import {getOffset} from './_getOffset';
import {getHeight} from './_getHeight';

export function sticky() {
  const stickyNavContainer = document.querySelectorAll('.js-sticky-container');
  if(stickyNavContainer) {
    for (let i = 0; i < stickyNavContainer.length; i++) {
      const _this = stickyNavContainer[i];
      const baseElement = _this;
      const fixedElement = _this.querySelector('.js-sticky');
      let baseElementOffsetTop = '';
      let baseElementOffsetBottom = '';
      let fixedElementHeight = ''

      const setSize = () => {
        const baseElementOffset = getOffset(baseElement);
        baseElementOffsetTop = baseElementOffset.top;
        baseElementOffsetBottom = baseElementOffsetTop + getHeight(baseElement);
        fixedElementHeight = getHeight(fixedElement)
      }

      const scroller = () => {
        const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        const scBottom = scTop+window.innerHeight;
        if(baseElementOffsetTop <= scTop) {
          fixedElement.classList.add('is-fixed');
          if(baseElementOffsetBottom <= scBottom) {
            fixedElement.classList.add('is-fixed-end');
          } else {
            fixedElement.classList.remove('is-fixed-end');
          }
        } else {
          fixedElement.classList.remove('is-fixed');
        }
        if(baseElementOffsetTop+fixedElementHeight*2 <= scBottom && baseElementOffsetBottom+fixedElementHeight >= scBottom) {
          fixedElement.classList.add('is-fixed-bottom');
          fixedElement.classList.remove('is-fixed-bottom-end');
        } else {
          fixedElement.classList.remove('is-fixed-bottom');
          if(baseElementOffsetBottom+fixedElementHeight <= scBottom) {
            fixedElement.classList.add('is-fixed-bottom-end');
          } else {
            fixedElement.classList.remove('is-fixed-bottom-end');
          }
        }
      }

      window.addEventListener('resize', () => {
        setSize();
        scroller();
      });

      window.addEventListener('scroll', scroller);
      
      setSize();
      scroller();
      fixedElement.classList.add('is-fixed-active');

      setInterval(() => {
        setSize();
        scroller();
      }, 2000)

      if(Typekit) {
        try {
          Typekit.load({
            active: function() {
              setTimeout(() => {
                setSize();
                scroller();
              }, 100);
            }
          })
        } catch(e) {}
      }
    }
  }
}